import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { FaRegTrashAlt } from "react-icons/fa";
import CartItem from "./cartItem";
import { SelectedPackage } from "types/promoType";

interface IProps {
  cartItems: SelectedPackage[];
  removeCartItem: (pkg: SelectedPackage) => void;
  clearCart: () => void;
}
const Cart = ({ cartItems, removeCartItem, clearCart }: IProps) => {
  return (
    <Container>
      <Header>
        <Typography size="2xl" weight="medium">
          Cart
        </Typography>
        <ClearAllContainer onClick={() => clearCart()}>
          <Typography color={Colors.danger}>Clear All</Typography>
          <FaRegTrashAlt color={Colors.danger} size={12} />
        </ClearAllContainer>
      </Header>
      <Body>
        {cartItems.map((cartItem, i) => {
          return (
            <CartItem
              key={i}
              pkg={cartItem}
              removeCartItem={(pkg) => removeCartItem(pkg)}
            />
          );
        })}
      </Body>
    </Container>
  );
};

export default Cart;

const Container = styled.div`
  width: 100%;
  border-radius: 8px;
  background-color: ${Colors.grey700};
  padding: 2.4rem;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1.6rem;
  margin-bottom: 2.4rem;
  border-bottom: 0.5px solid ${Colors.grey600};
  width: 100%;
`;

const ClearAllContainer = styled.div`
  display: flex;
  align-items: "center";
  gap: 0.5rem;
  cursor: pointer;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;
